import { Actions } from 'src/store/actions/app-actions';
import { failureType, requestType, successType } from '../../services/api-handlers/api-resolver';
import { AppActions } from '../constants';
import user from 'src/services/user-auth';
import orderEnum from 'src/enumerables/order-enum';
import caseEnum from 'src/enumerables/case-enum';
import generalEnum from 'src/enumerables/general-enum';
import seanceEnum from 'src/enumerables/seance-enum';
import { IAgencyInfo } from 'src/types/app';
import GeneralEnum from '../../enumerables/general-enum';

export interface BaseConfig {}

export interface AppState {
    baseConfig: BaseConfig;
    dashBoardData: any;
    agencyInfo: IAgencyInfo | null;
    currentAgencyFiles: any | null;
    miniLoaderFor: { [key: string]: boolean };
    inProgress: boolean;
    error: string;
}

// Define initial state
const initialState = {
    baseConfig: {},
    dashBoardData: {},
    agencyInfo: null,
    miniLoaderFor: {},
    currentAgencyFiles: null,
    inProgress: false,
    error: '',
};

export function app(state: AppState = initialState, action: Actions | any): AppState {
    switch (action.type) {
        case requestType(AppActions.APP_MOUNT):
            return { ...state, error: '', inProgress: true };
        case successType(AppActions.APP_MOUNT):
            user.setAllRoles(action.payload.UserRole);
            user.setAllStatuses(action.payload.UserStatus);
            user.setUserAvailableStatus(action.payload.UserAvailableStatus);
            user.setStudentAvailableStatus(action.payload.StudentStatus);
            orderEnum.setEnum({
                AllocatedPeriod: action.payload.AllocatedPeriod,
                AuthorizationSource: action.payload.AuthorizationSource,
                OrderStatus: action.payload.OrderStatus,
                OrderSubtype: action.payload.OrderSubtype,
                OrderType: action.payload.OrderType,
                ServiceTypeProvider: action.payload.ServiceTypeProvider,
                OrderCaseType: action.payload.OrderCaseType,
                ReferralSource: action.payload.ReferralSource,
            });
            caseEnum.setEnum({
                caseType: action.payload.CaseType,
                CaseStatus: action.payload.CaseStatus,
                CaseFilterStatus: action.payload.CaseFilterStatus,
                MinPerUnit: action.payload.MinPerUnit,
                InvoiceSigner: action.payload.InvoiceSigner,
                OrderType_1: action.payload.OrderType_1,
                OrderType_2: action.payload.OrderType_2,
                OrderType_3: action.payload.OrderType_3,
                OrderType_4: action.payload.OrderType_4,
                OrderType_5: action.payload.OrderType_5,
            });
            seanceEnum.setEnum({
                SeanceStatus: action.payload.SeanceStatus,
                SeanceFilterDatasheet: action.payload.SeanceFilterDatasheet,
            });

            generalEnum.setEnum({
                InvoiceStatus: action.payload.InvoiceStatus,
                InvoiceSigner: action.payload.InvoiceSigner,
                IntakeType: action.payload.IntakeType,
                ContractLanguage: action.payload.ContractLanguage,
                ContractStatus: action.payload.ContractStatus,
                ContractStatusDocusign: action.payload.ContractStatusDocusign,
                //IntakeAbaBehaviors: action.payload.IntakeAbaBehaviors,
                //IntakeAbaCommunications: action.payload.IntakeAbaCommunications,
                //IntakeAbaInterests: action.payload.IntakeAbaInterests,
                //IntakeAbaSocials: action.payload.IntakeAbaSocials,
                IntakeAbaSpecialProcedures: action.payload.IntakeAbaSpecialProcedures,
                //IntakeOneACurrentSpecialists: action.payload.IntakeOneACurrentSpecialists,
                //IntakeOneACurrentSymptoms: action.payload.IntakeOneACurrentSymptoms,
                IntakeOneABadHabits: action.payload.IntakeOneABadHabits,
                IntakeStatus: action.payload.IntakeStatus,
                PaymentStatus: action.payload.PaymentStatus,
                PaymentCreditStatus: action.payload.PaymentCreditStatus,
                AdminWorkStatus: action.payload.AdminWorkStatus,
                ExpenseStatus: action.payload.ExpenseStatus,
                InternalStatus: action.payload.InternalStatus,
                PayrollStatus: action.payload.PayrollStatus,
                EnvelopeSignerType: action.payload.EnvelopeSignerType,
                EnvelopeSignerStatus: action.payload.EnvelopeSignerStatus,
                EnvelopeStatus: action.payload.EnvelopeStatus,
                UserStatus: action.payload.UserStatus,
                ProgramType: action.payload.ProgramType,
                ProgramPrompt: action.payload.ProgramPrompt,
                MasteryDirection: action.payload.MasteryDirection,
                BonusStatus: action.payload.BonusStatus,
                BonusType: action.payload.BonusType,
                ComparisonCondition: action.payload.ComparisonCondition,
                PeriodCondition: action.payload.PeriodCondition,
            });

            return { ...state, baseConfig: action.payload, inProgress: false };

        case failureType(AppActions.APP_MOUNT):
            return { ...state, error: action.error, inProgress: false };

        case successType(AppActions.CREATE_FILES_AGENCY):
            const curFiles = [...(state.currentAgencyFiles ?? [])];
            curFiles.push(action.payload);

            return {
                ...state,
                miniLoaderFor: {},
                currentAgencyFiles: curFiles,
            };
        case requestType(AppActions.CREATE_FILES_AGENCY):
            return { ...state, error: '', miniLoaderFor: { FILE_AGENCY: true } };
        case failureType(AppActions.CREATE_FILES_AGENCY):
            return { ...state, miniLoaderFor: {}, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        case requestType(AppActions.APP_FETCH_AGENCY):
            return { ...state, error: '', inProgress: true };
        case successType(AppActions.APP_FETCH_AGENCY):
            const info = action.payload ? action.payload.list[0] : {};
            if (info.logoDoc) {
                const logoDoc = GeneralEnum.getEnum('logoDoc');
                if (info.logoDoc !== logoDoc) {
                    generalEnum.setEnum({
                        logoDoc: info.logoDoc,
                    });
                }
            }
            return { ...state, agencyInfo: info, inProgress: false };
        case failureType(AppActions.APP_FETCH_AGENCY):
            return { ...state, error: action.error, inProgress: false };

        case requestType(AppActions.APP_FETCH_DASHBOARD):
            return { ...state, error: '', inProgress: true };

        case failureType(AppActions.APP_FETCH_DASHBOARD):
            return { ...state, error: action.error, inProgress: false };
        case successType(AppActions.APP_FETCH_DASHBOARD):
            return { ...state, dashBoardData: action.payload, inProgress: false };
        case requestType(AppActions.APP_UPDATE_AGENCY):
            return { ...state, error: '', inProgress: true };
        case successType(AppActions.APP_UPDATE_AGENCY):
            return { ...state, agencyInfo: action.payload, inProgress: false };
        case failureType(AppActions.APP_UPDATE_AGENCY):
            return { ...state, error: action.error, inProgress: false };
        default:
            return state;
    }
}
